export default __webpack_public_path__ + "static/media/seashell1.0ab9decc.svg";